const envConfig = {
  e0: {
    EPCC_TOKEN_URL: 'https://oneidentityapi-dev.aexp.com/security/digital/v1/application/token',
    EPCC_SEARCH_URL: 'http://localhost:8012/proxy/privacy/preferences/search',
    EPCC_UPDATE_URL: 'http://localhost:8014/proxy/privacy/preferences',
    EPCC_INTERFACE_RELATIONSHIP_ID: '7253',
    CARD_LIST_URL: 'http://localhost:8011/proxy/account_servicing/member/v1/accounts',
    MASTER_COMM_URL: 'https://digmetadata-qa.aexp.com/myca/dig/resthub/occ/getCommMasterData',
    ACCOUNTS_API: 'http://localhost:8016/proxy/ecommsvc/eaddser/api/v1/email/accounts',
    MASTER_COMM_APP_ID: 'pxIaENR8HoQyumoG2WN0ew==',
    CARD_API_TOKEN: 'https://tokenizersvc-qa.aexp.com/'
  },
  e1: {
    EPCC_TOKEN_URL: 'https://oneidentityapi-dev.aexp.com/security/digital/v1/application/token',
    EPCC_SEARCH_URL: 'https://optioinquiry-dev.aexp.com/privacy/preferences/search',
    EPCC_UPDATE_URL: 'https://optiocorenew-dev.aexp.com/privacy/preferences',
    EPCC_INTERFACE_RELATIONSHIP_ID: '7253',
    CARD_LIST_URL: 'https://memactglobalsvc-qa.aexp.com/account_servicing/member/v1/accounts',
    MASTER_COMM_URL: 'https://digmetadata-qa.aexp.com/myca/dig/resthub/occ/getCommMasterData',
    ACCOUNTS_API: 'https://eaddsvc-qaeusw1a4.aexp.com/ecommsvc/eaddser/api/v1/email/accounts',
    MASTER_COMM_APP_ID: 'pxIaENR8HoQyumoG2WN0ew==',
    CARD_API_TOKEN: 'https://tokenizersvc-qa.aexp.com/'
  },
  e2: {
    EPCC_TOKEN_URL: 'https://oneidentityapi-qa.aexp.com/security/digital/v1/application/token',
    EPCC_SEARCH_URL: 'https://optioinquiry-qa.aexp.com/privacy/preferences/search',
    EPCC_UPDATE_URL: 'https://optiocorenew-qa.aexp.com/privacy/preferences',
    EPCC_INTERFACE_RELATIONSHIP_ID: '7503',
    CARD_LIST_URL: 'https://memactglobalsvc-qa.aexp.com/account_servicing/member/v1/accounts',
    MASTER_COMM_URL: 'https://digmetadata-qa.aexp.com/myca/dig/resthub/occ/getCommMasterData',
    ACCOUNTS_API: 'https://eaddsvc-qaeusw1a4.aexp.com/ecommsvc/eaddser/api/v1/email/accounts',
    MASTER_COMM_APP_ID: 'pxIaENR8HoQyumoG2WN0ew==',
    CARD_API_TOKEN: 'https://tokenizersvc-qa.aexp.com/'
  },
  e3: {
    EPCC_TOKEN_URL: 'https://oneidentityapi.aexp.com/security/digital/v1/application/token',
    EPCC_SEARCH_URL: 'https://optioinquiry.aexp.com/privacy/preferences/search',
    EPCC_UPDATE_URL: 'https://optiocorenew.aexp.com/privacy/preferences',
    EPCC_INTERFACE_RELATIONSHIP_ID: '5692',
    CARD_LIST_URL: '',
    MASTER_COMM_URL: '',
    ACCOUNTS_API: '',
    MASTER_COMM_APP_ID: '',
    CARD_API_TOKEN: ''
  }
};
module.exports = envConfig;